import { InjectionToken } from '@angular/core';
import { OverlayRef } from '@angular/cdk/overlay';
import { IPlanogram } from '../../../models/planogram';

export interface PlanogramCanvasWidgetData {
	planogram: IPlanogram;
	hostContainer: HTMLElement;
	overlayRef: OverlayRef;
	editable: boolean;
}

export interface PlanogramCanvasWidgetRef {
	focus: () => void;
	close: () => void;
}

export const PLANOGRAM_CANVAS_WIDGET_DATA = new InjectionToken<PlanogramCanvasWidgetData>('PLANOGRAM_CANVAS_WIDGET_DATA');
export const PLANOGRAM_CANVAS_WIDGET_REF = new InjectionToken<PlanogramCanvasWidgetRef>('PLANOGRAM_CANVAS_WIDGET_REF');
